/* import __COLOCATED_TEMPLATE__ from './create-payoneer-account-card.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { PAYOUT_ACCOUNT } from '../../../models/payout-account';
import { PAYOUT_METHOD } from '../../../models/payout-method';
import { getAccountMethodIcon } from '../../../constants/payout';

const CLASS_NAME = 'SH-c-create-payoneer-account-card';

const ICON_NAME = getAccountMethodIcon(PAYOUT_ACCOUNT.ACCOUNT_TYPES.PAYONEER);

const STATUS_OPTIONS = Object.keys(PAYOUT_ACCOUNT.STATUSES).map((key) => {
  const label = PAYOUT_ACCOUNT.STATUS_NAMES[PAYOUT_ACCOUNT.STATUSES[key].toString()];
  return {
    key: label,
    model: { id: PAYOUT_ACCOUNT.STATUSES[key], label },
  };
});

export default Component.extend({
  tagName: '',
  CLASS_NAME,
  ICON_NAME,
  STATUS_OPTIONS,

  /** @param {Function} */
  onCreate: () => {},

  /** @param {Boolean} */
  disabled: false,

  accountType: PAYOUT_ACCOUNT.ACCOUNT_TYPES.PAYONEER,
  accountMethod: PAYOUT_METHOD.PAYONEER_ACCOUNT_METHODS.PAYONEER_CARD,
  status: null,
  providerId: '',

  /** @type {String} */
  statusSelectedOption: computed('status', function () {
    const id = this.get('status');
    return id !== null ? PAYOUT_ACCOUNT.STATUS_NAMES[id] : '';
  }),

  actions: {
    handleInput(field, value) {
      this.set(field, value);
    },

    handleStatusSelect(status) {
      this.set('status', status.id);
    },

    handleCreate() {
      const data = this.getProperties(['accountType', 'accountMethod', 'status', 'providerId']);
      this.get('onCreate')(data);
    },
  },
});
